<ng-container *ngIf="!preview">
  <div class="main-wrapper">
    <!-- <p>Fields containing an * are mandatory</p> -->
    <p>{{ languageService.languageConfig?.mandatory_fields_note }}</p>
  </div>
  <div class="d-flex justify-content-center mt-2 align-items-center min-vh-100">
    <form [formGroup]="signatureForm" (ngSubmit)="onSubmit()" class="w-50">
      <div class="form-floating no-float mb-3">
        <input type="text" id="firstname" class="form-control" placeholder="First Name" formControlName="firstname"
          required />
        <label for="firstname" class="">{{ languageService.languageConfig?.form_labels.firstName }} *</label>
      </div>

      <div class="form-floating no-float mb-3">
        <input type="text" id="lastname" class="form-control" placeholder="Last Name" formControlName="lastname"
          required />
        <label for="lastname">{{ languageService.languageConfig?.form_labels.lastName }} *</label>
      </div>

      <div class="form-floating no-float mb-3">
        <input type="text" id="function" class="form-control" placeholder="Function" formControlName="function" />
        <label for="function">{{
          languageService.languageConfig?.form_labels.function
          }}</label>
      </div>

      <div class="form-floating no-float mb-3">
        <input type="text" id="division" class="form-control" placeholder="Division" formControlName="division" />
        <label for="division">{{
          languageService.languageConfig?.form_labels.division
          }}</label>
      </div>

      <div class="form-floating no-float mb-3">
        <input type="text" id="title" class="form-control" placeholder="Title" formControlName="title" required />
        <label for="title">{{ languageService.languageConfig?.form_labels.title }} *</label>
      </div>

      <div class="form-floating no-float mb-3">
        <select id="legalCompany" class="form-select" formControlName="legalCompany">
          <option value="" disabled selected>
            {{ languageService.languageConfig?.form_labels.selectACompany }}
          </option>
          <option value="">None</option>
          <option *ngFor="let companyName of companiesName" [value]="companyName">
            {{ companyName }}
          </option>
          <option value="">Duro-Last</option>
          <option value="">Enverge</option>
        </select>
        <label for="legalCompany">{{
          languageService.languageConfig?.form_labels.companyName
          }}</label>
      </div>

      <div class="form-floating no-float mb-3">
        <select id="urlSelect" class="form-select" formControlName="url" required>
          <option value="" disabled selected>
            {{ languageService.languageConfig?.form_labels.selectAURL }}
          </option>
          <option *ngFor="let item of urls" [value]="item">{{ item }}</option>
        </select>
        <label class="label-wrapper" for="urlSelect">{{ languageService.languageConfig?.form_labels.companyURL }}
          *</label>
      </div>

      <div class="form-floating no-float mb-3">
        <input type="text" id="address" class="form-control" placeholder="Address" formControlName="address" />
        <label for="address">{{
          languageService.languageConfig?.form_labels.address
          }}</label>
      </div>

      <div class="form-floating no-float mb-3">
        <input type="text" id="postcode" class="form-control" placeholder="Post Code" formControlName="postcode" />
        <label for="postcode">{{
          languageService.languageConfig?.form_labels.postCode
          }}</label>
      </div>

      <div class="form-floating no-float mb-3">
        <input type="text" id="city" class="form-control" placeholder="City / State" formControlName="city" />
        <label for="city">{{
          languageService.languageConfig?.form_labels.city
          }}</label>
      </div>

      <div class="form-floating no-float mb-3">
        <input type="text" id="country" class="form-control" placeholder="Country" (input)="onInputChange()"
          autocomplete="off" formControlName="country" />
        <label for="country">{{
          languageService.languageConfig?.form_labels.country
          }}</label>

        <div class="suggestions" *ngIf="filteredCountries.length > 0">
          <div class="suggestion-item" *ngFor="let country of filteredCountries" (click)="selectCountry(country)">
            {{ country }}
          </div>
        </div>
      </div>

      <div class="form-floating no-float mb-3">
        <input type="text" id="phone" class="form-control" placeholder="Phone" formControlName="phone" />
        <label for="phone">{{
          languageService.languageConfig?.form_labels.phone
          }}</label>
      </div>

      <div class="form-floating no-float mb-3">
        <input type="text" id="mobile" class="form-control" placeholder="Mobile" formControlName="mobile" />
        <label for="mobile">{{
          languageService.languageConfig?.form_labels.mobile
          }}</label>
      </div>

      <div class="form-floating no-float mb-3">
        <input type="text" id="fax" class="form-control" placeholder="Fax" formControlName="fax" />
        <label for="fax">{{
          languageService.languageConfig?.form_labels.fax
          }}</label>
      </div>

      <div class="form-floating no-float mb-3">
        <input type="text" id="newemail" class="form-control" placeholder="Email" formControlName="newemail" />
        <label for="newemail">{{ languageService.languageConfig?.form_labels.newEmail }} *</label>
      </div>
      <div class="form-floating no-float mb-3">
        <select id="bannerSelect" class="form-select" formControlName="marketBrand" [compareWith]="compareBrands">
          <option value="" disabled selected>
            {{ languageService.languageConfig?.form_labels.selectABrand }}
          </option>
          <option value="">Amrize</option>
          <option *ngFor="let brand of brandsList" [ngValue]="brand">
            {{ brand.brandName }}
          </option>
        </select>
        <label class="label-wrapper" for="bannerSelect">{{
          languageService.languageConfig?.form_labels.brand
          }}</label>
      </div>
      @if (!signatureForm.value?.marketBrand?.brandName) {
      <div class="form-floating no-float mb-3">
        <select id="bannerSelect" class="form-select" formControlName="banner">
          <option value="" disabled selected>
            {{ languageService.languageConfig?.form_labels.selectABanner }}
          </option>
          <option *ngFor="let banner of languageService.languageConfig?.banners" [value]="banner.bannerUrl">
            {{ banner.bannerName }}
          </option>
        </select>
        <label class="label-wrapper" for="bannerSelect">{{
          languageService.languageConfig?.form_labels.banners
          }}</label>
      </div>
      }
      <!-- <div class="form-floating no-float mb-3">
        <select id="promoBannerSelect" class="form-select" formControlName="promotionalBanner">
          <option value="" disabled selected> Select a Promotional Banner</option>
          <option *ngFor="let title of promotionalBanners" [value]="title.id">{{ title.title }}</option>
        </select>
        <label class="label-wrapper" for="promoBannerSelect">Choose a promotional banner to</label>
      </div> -->
      <div class="mb-3">
        <quill-editor class="w-100" formControlName="additionalInfo" [modules]="editorModules" [placeholder]="''"
          theme="snow">
        </quill-editor>
        <div style="font-size: small">
          {{ languageService.languageConfig?.desciption_Note }}
        </div>
      </div>

      <div class="d-flex justify-content-start align-items-center mb-2 w-5">
        <button type="submit" class="btn btn-sm btn-primary p-2" style="width: fit-content">
          {{ languageService.languageConfig?.form_labels.submitToPreview }}
        </button>
      </div>
    </form>
  </div>
</ng-container>

<ng-container *ngIf="preview">
  <div dir="ltr" class="email_signature" data-smartmail="email_signature" id="signature">
    <div dir="ltr">
      <div class="name">
        <span>{{ signatureForm.value.firstname + " " }}</span>
        <span>{{ signatureForm.value.lastname }}</span>
      </div>
      <div class="title">
        <span>{{ signatureForm.value.title | capitalize }}</span>
      </div>
      <div class="email mb-3">
        <span>
          <a class="link-wrapper" [href]="'mailto:' + signatureForm.value.newemail" target="_blank" rel="noopener">
            {{ signatureForm.value.newemail }}
          </a>
        </span>
      </div>
      <!-- @if (signatureForm.value?.marketBrand) {
      <div class="logo"><img [src]="signatureForm.value?.marketBrand" alt="logo"></div>
      } -->
      @if (signatureForm.value?.marketBrand?.brandLogo) { @if
      (signatureForm.value?.marketBrand?.brandLogo.includes(',') &&
      signatureForm.value?.marketBrand?.brandLogo.split(',').length>1) {
      <div class="logo">
        @for (item of signatureForm.value?.marketBrand?.brandLogo.split(',');
        track $index) {
        <img [src]="item" alt="logo" [ngClass]="$index === 1 ? 'ms-4' : ''" />
        }
      </div>
      }@else{
      <div class="logo">
        <img [src]="signatureForm.value?.marketBrand?.brandLogo" alt="logo" />
      </div>
      } }

      @if (signatureForm.value?.marketBrand?.brandName === "Gaco and Enverge") {
        <table cellpadding="0" cellspacing="0"
          style="border: 0.5px solid #767676; background-color: #EFEFEF; margin-top: 10px; font-family: Arial, sans-serif; border-collapse: collapse;">
          <tr>
            <td valign="middle"
              style="padding: 10px 12px 10px 14px; font-size: 18pt; line-height: 1;">
              💬
            </td>
            <td valign="middle"
              style="padding: 8px 30px 8px 0px; font-size: 10pt; line-height: 1.35;">
              <span style="color: #000000; font-weight: bold; font-size: 10.5pt;">
                How was your experience with us?
              </span>
              <br>
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSf0GyXLPmuTiIuGMEu7jCW60TThSTAcUwcLkXaONTaumZu3nQ/viewform"
                target="_blank"
                rel="noopener"
                style="color: #0F3A86; text-decoration: underline;">
                Help us improve by Completing a Short Survey
              </a>
            </td>
          </tr>
        </table>
      }
      
      <div class="brand-name mt-3">
        <span>{{ signatureForm.value.legalCompany }}</span>
      </div>
      <div class="address">
        <span id="addr1" *ngIf="signatureForm.value.address">{{
          signatureForm.value.address
          }}</span>
        <span *ngIf="
            signatureForm.value.address &&
            (signatureForm.value.city ||
              signatureForm.value.country ||
              signatureForm.value.postcode)
          ">{{ ", " }}</span>
        <span *ngIf="signatureForm.value.city">{{
          signatureForm.value.city
          }}</span>
        <span *ngIf="
            signatureForm.value.city &&
            (signatureForm.value.country || signatureForm.value.postcode)
          ">{{ ", " }}</span>
        <span *ngIf="signatureForm.value.country">{{
          signatureForm.value.country
          }}</span>
        <span *ngIf="signatureForm.value.country && signatureForm.value.postcode">{{ ", " }}</span>
        <span *ngIf="signatureForm.value.postcode">{{
          signatureForm.value.postcode
          }}</span>
      </div>
      <div class="address">
        <span *ngIf="signatureForm.value.phone">
          {{ "T: " + signatureForm.value.phone }}</span>
        <span *ngIf="signatureForm.value.phone && signatureForm.value.mobile">{{
          ", "
          }}</span>
        <span *ngIf="signatureForm.value.mobile">{{
          "M: " + signatureForm.value.mobile
          }}</span>
      </div>

      <div class="address">
        <div style="font-size: 9pt; color: #011e6a">
          @if (!signatureForm.value?.marketBrand?.brandName) {
          <a href="http://amrize.com/" target="_blank" style="color: #011e6a">Amrize</a>
          |
          <a href="https://www.linkedin.com/company/amrize/" target="_blank" style="color: #011e6a">LinkedIn</a>
          |
          <a href="https://www.facebook.com/amrize.ltd" target="_blank" style="color: #011e6a">Facebook</a>
          }@else {
          @if(signatureForm.value?.marketBrand?.brandName !== "Gaco and Enverge") {
          @if (BE_BRANDS.includes(signatureForm.value?.marketBrand?.brandName)) {
          <a [href]="signatureForm.value?.marketBrand?.website" target="_blank" style="color: #011e6a">{{
            signatureForm.value?.marketBrand?.brandName }}</a>
          }@else {
          <a href="http://amrize.com/" target="_blank" style="color: #011e6a">Amrize</a>
          }
          }
          @if(signatureForm.value?.marketBrand?.brandName === "Gaco and Enverge") {
          <a href="https://gaco.com/" target="_blank" style="color: #011e6a">Gaco</a>
          |
          <a href="https://www.linkedin.com/company/gaco/" target="_blank" style="color: #011e6a">LinkedIn</a>
          |
          <a href="https://www.facebook.com/GacoWestern" target="_blank" style="color: #011e6a">Facebook</a>

          <a href="https://envergesprayfoam.com/" target="_blank" style="color: #011e6a; margin-left: 20px;">Enverge</a>
          |
          <a href="https://www.linkedin.com/company/enverge-spray-foam/" target="_blank"
            style="color: #011e6a">LinkedIn</a>
          |
          <a href="https://www.facebook.com/EnvergeSprayFoam" target="_blank" style="color: #011e6a">Facebook</a>
          |
          <a href="https://www.instagram.com/enverge_sprayfoam/" target="_blank" style="color: #011e6a">Instagram</a>
          }@else{

          @if (signatureForm.value?.marketBrand?.linkedin) {
          |
          <a [href]="signatureForm.value?.marketBrand?.linkedin" target="_blank" style="color: #011e6a">LinkedIn</a>
          }
          @if (signatureForm.value?.marketBrand?.facebook) {
          |
          <a [href]="signatureForm.value?.marketBrand?.facebook" target="_blank" style="color: #011e6a">Facebook</a>
          }
          @if (signatureForm.value?.marketBrand?.youtube) {
          |
          <a [href]="signatureForm.value?.marketBrand?.youtube" target="_blank" style="color: #011e6a">YouTube</a>
          }
          @if (signatureForm.value?.marketBrand?.instagram) {
          |
          <a [href]="signatureForm.value?.marketBrand?.instagram" target="_blank" style="color: #011e6a">Instagram</a>
          }
          @if (safeTikTokUrl) {
          |
          <a [href]="safeTikTokUrl" target="_blank" style="color: #011e6a">TikTok</a>
          }
          }
          }
        </div>
      </div>
      <div *ngIf="BE_BRANDS.includes(signatureForm.value?.marketBrand?.brandName)" style="margin-top: 5px;">
        <span style="font-size: 9pt; color: #011e6a; font-weight: bold;">{{
          signatureForm.value?.marketBrand?.brandName +
          languageService.languageConfig?.brandTagline
          }}</span>
      </div>
      <div class="description">
        <span [innerHTML]="signatureForm.value.additionalInfo"></span>
      </div>
      @if (!signatureForm.value?.marketBrand?.brandName) {
      <div class="logo">
        <img [src]="signatureForm.value.banner" alt="logo" class="logo" />
      </div>
      }@else {
      <div>
        <img [src]="languageService.languageConfig?.amrizeStripe" alt="logo" width="90%" />
      </div>
      }
      <div class="mt-2">
        <span style="font-size: 9pt; color: #011e6a">
          {{ languageService.languageConfig?.email_signature_disclaimer }}
        </span>
      </div>
    </div>
  </div>

  <div class="d-flex">
    <div class="col-2 me-3">
      <button class="btn button1 px-4 w-100" (click)="preview = false">
        < {{ languageService.languageConfig?.form_labels.goBack }} </button>
    </div>
    <div class="col-2">
      <button class="btn button1 px-4 w-100" (click)="submitFinalSignature()">
        {{ languageService.languageConfig?.form_labels.setMySignature }}
      </button>
    </div>
  </div>
</ng-container>